import styled from "styled-components";

export const DisclaimerContainer = styled.div(props => ({
textAlign:"left",  
fontSize:"1rem"
}));